import { useNotificationQueryContext } from "../../context/NotificationQueryContext";
import { useNotifications } from "../../hooks/notifications/useNotifications";

/**
 * SelectAllCheckbox Component
 *
 * Checkbox for selecting/deselecting all notifications
 * Shows indeterminate state when some notifications are selected
 */
const SelectAllCheckbox = ({ className = "" }) => {
  const { selectedNotifications, selectAllNotifications, queryParams } =
    useNotificationQueryContext();
  const { data: notificationsData } = useNotifications(queryParams);

  const notifications = notificationsData?.data?.notifications || [];
  const totalCount = notifications.length;
  const selectedCount = selectedNotifications.length;
  const isAllSelected = totalCount > 0 && selectedCount === totalCount;
  const isIndeterminate = selectedCount > 0 && selectedCount < totalCount;

  // Handle select all toggle
  const handleSelectAll = (event) => {
    const shouldSelectAll = event.target.checked;
    const allNotificationIds = notifications.map((n) => n._id);
    selectAllNotifications(shouldSelectAll, allNotificationIds);
  };

  if (totalCount === 0) {
    return null;
  }

  return (
    <div className={`select-all-checkbox flex items-center ${className}`}>
      <input
        type="checkbox"
        checked={isAllSelected}
        ref={(input) => {
          if (input) {
            input.indeterminate = isIndeterminate;
          }
        }}
        onChange={handleSelectAll}
        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        aria-label={
          isAllSelected
            ? "Deselect all notifications"
            : "Select all notifications"
        }
      />
      <label className="ml-2 text-sm text-gray-700">
        {isAllSelected
          ? "Deselect all"
          : isIndeterminate
          ? `${selectedCount} of ${totalCount} selected`
          : "Select all"}
      </label>
    </div>
  );
};

export default SelectAllCheckbox;
